<app-modal-base [title]="dialogTitle" [hasCancel]="false" [hasSubmit]="false">
  <ng-container main *ngTemplateOutlet="content"></ng-container>
</app-modal-base>

<ng-template #content>
  <div mat-dialog-content>
    <div class="content">
      <p>Merci d'avoir créer votre compte sur notre plateforme EEMO !</p>
      <p>&nbsp;</p>
      <p>
        Pour vous aidez à bien démarrer, nous vous proposons un petit guide de
        prise en main.
      </p>
      <p>&nbsp;</p>
      <p>
        <button
          mat-flat-button
          class="p-4"
          color="primary"
          (click)="showWelcomMessage()"
        >
          {{ "showGuide" | translate }}
        </button>
      </p>
      <p>&nbsp;</p>
      <p>Notre équipe support est à votre disposition.</p>
      <p>
        N'hésitez pas à nous contacter depuis le centre d'aide de l'application
        !
      </p>
    </div>
  </div></ng-template
>
